import { useGoogleLogin } from '@react-oauth/google';
import { useStore } from '../../../helpers/use-store';
import { useNotification } from '../../../hooks/use-notification';
import { useTranslation } from 'react-i18next';

interface UseYouTubeAuthProps {
  onSuccess?: () => void;
}

export const useYouTubeAuth = ({ onSuccess }: UseYouTubeAuthProps = {}) => {
  const {
    dataStore: { socialAccountStore },
  } = useStore();
  const notificationApi = useNotification();
  const { t } = useTranslation();

  const login = useGoogleLogin({
    flow: 'auth-code',
    scope: [
      'https://www.googleapis.com/auth/youtube.force-ssl',
      'https://www.googleapis.com/auth/youtube.upload',
      'https://www.googleapis.com/auth/youtube.readonly',
    ].join(' '),
    onSuccess: async (codeResponse) => {
      try {
        const response = await socialAccountStore.youtubeAuth(
          codeResponse.code
        );
        if (response) {
          notificationApi.success({
            placement: 'top',
            icon: '',
            message: t('common.success'),
            description: t('socialAccounts.youtube.addedSuccess'),
          });

          onSuccess?.();
        }
      } catch (error) {
        console.error('YouTube auth error:', error);
      }
    },
    onError: (errorResponse) => {
      notificationApi.error({
        placement: 'top',
        icon: '',
        message: t('common.error'),
        description: t('socialAccounts.youtube.addError'),
      });
      console.error('Google login error:', errorResponse);
    },
  });

  return { handleAuth: login };
};
